import { AppointmentCase, QuoteDetail } from '@quorum/models/xs-resource';
import { AppointmentCaseQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum AppointmentCasesEntityActionTypes {
  GetAppointmentCasesFromServer = '[Fixed Operations] Get Appointment Cases From Server',
  GetAppointmentCasesFromServerError = '[Fixed Operations] Get Appointment Cases From Server Error',
  GetAppointmentCasesFromServerSuccess = '[Fixed Operations] Get Appointment Cases From Server Success',
  UpdateAppointmentCaseOnServer = '[Fixed Operations] Update Appointment Case From Server',
  UpdateAppointmentCaseOnServerError = '[Fixed Operations] Update Appointment Case From Server Error',
  UpdateAppointmentCaseOnServerSuccess = '[Fixed Operations] Update Appointment Case From Server Success',
  DeleteAppointmentCaseOnServer = '[Fixed Operations] Delete Appointment Case From Server',
  DeleteAppointmentCaseOnServerError = '[Fixed Operations] Delete Appointment Case From Server Error',
  DeleteAppointmentCaseOnServerSuccess = '[Fixed Operations] Delete Appointment Case From Server Success',
  CreateAppointmentCaseOnServer = '[Fixed Operations] Create Appointment Case From Server',
  CreateAppointmentCaseOnServerError = '[Fixed Operations] Create Appointment Case From Server Error',
  CreateAppointmentCaseOnServerSuccess = '[Fixed Operations] Create Appointment Case From Server Success'
}

//#region message-types
export class GetAppointmentCasesFromServer implements Action {
  readonly type = AppointmentCasesEntityActionTypes.GetAppointmentCasesFromServer;
  constructor(public payload: { params: AppointmentCaseQueryParameters; returnAction: any }) {}
}
export class GetAppointmentCasesFromServerError implements Action {
  readonly type = AppointmentCasesEntityActionTypes.GetAppointmentCasesFromServerError;
  constructor(public payload: any) {}
}
export class GetAppointmentCasesFromServerSuccess implements Action {
  readonly type = AppointmentCasesEntityActionTypes.GetAppointmentCasesFromServerSuccess;
  constructor(public payload: AppointmentCase[]) {}
}

export class UpdateAppointmentCaseOnServer implements Action {
  readonly type = AppointmentCasesEntityActionTypes.UpdateAppointmentCaseOnServer;
  constructor(public payload: AppointmentCase) {}
}
export class UpdateAppointmentCaseOnServerError implements Action {
  readonly type = AppointmentCasesEntityActionTypes.UpdateAppointmentCaseOnServerError;
  constructor(public payload: any) {}
}
export class UpdateAppointmentCaseOnServerSuccess implements Action {
  readonly type = AppointmentCasesEntityActionTypes.UpdateAppointmentCaseOnServerSuccess;
  constructor(public payload: AppointmentCase) {}
}

export class DeleteAppointmentCaseOnServer implements Action {
  readonly type = AppointmentCasesEntityActionTypes.DeleteAppointmentCaseOnServer;
  constructor(public payload: AppointmentCase) {}
}
export class DeleteAppointmentCaseOnServerError implements Action {
  readonly type = AppointmentCasesEntityActionTypes.DeleteAppointmentCaseOnServerError;
  constructor(public payload: any) {}
}
export class DeleteAppointmentCaseOnServerSuccess implements Action {
  readonly type = AppointmentCasesEntityActionTypes.DeleteAppointmentCaseOnServerSuccess;
  constructor(public payload: AppointmentCase) {}
}

export class CreateAppointmentCaseOnServer implements Action {
  readonly type = AppointmentCasesEntityActionTypes.CreateAppointmentCaseOnServer;
  constructor(public payload: { appointmentCase: AppointmentCase; quoteLine: QuoteDetail }) {}
}
export class CreateAppointmentCaseOnServerError implements Action {
  readonly type = AppointmentCasesEntityActionTypes.CreateAppointmentCaseOnServerError;
  constructor(public payload: any) {}
}
export class CreateAppointmentCaseOnServerSuccess implements Action {
  readonly type = AppointmentCasesEntityActionTypes.CreateAppointmentCaseOnServerSuccess;
  constructor(public payload: { appointmentCase: AppointmentCase; quoteLine: QuoteDetail }) {}
}
//#endregion

export type AppointmentCasesEntityAction =
  | GetAppointmentCasesFromServer
  | GetAppointmentCasesFromServerError
  | GetAppointmentCasesFromServerSuccess
  | UpdateAppointmentCaseOnServer
  | UpdateAppointmentCaseOnServerError
  | UpdateAppointmentCaseOnServerSuccess
  | DeleteAppointmentCaseOnServer
  | DeleteAppointmentCaseOnServerError
  | DeleteAppointmentCaseOnServerSuccess
  | CreateAppointmentCaseOnServer
  | CreateAppointmentCaseOnServerError
  | CreateAppointmentCaseOnServerSuccess;

export const fromAppointmentCasesEntityActions = {
  GetAppointmentCasesFromServer,
  GetAppointmentCasesFromServerError,
  GetAppointmentCasesFromServerSuccess,
  UpdateAppointmentCaseOnServer,
  UpdateAppointmentCaseOnServerError,
  UpdateAppointmentCaseOnServerSuccess,
  DeleteAppointmentCaseOnServer,
  DeleteAppointmentCaseOnServerError,
  DeleteAppointmentCaseOnServerSuccess,
  CreateAppointmentCaseOnServer,
  CreateAppointmentCaseOnServerError,
  CreateAppointmentCaseOnServerSuccess
};
